import api from '../../services/api';

const RECURSO_PARTICIPACAO = '/atendimentos/linha-cuidado/';
const RECURSO_PACIENTE = '/atendimentos/linha-cuidado/paciente/';

class LinhaCuidadoService {
    obterParticipacao(atendimentoId) {
        return api.get(RECURSO_PARTICIPACAO, { params: { atendimento_id: atendimentoId } });
    }

    atualizarParticipacao(atendimentoId, dados) {
        return api.put(RECURSO_PARTICIPACAO, { atendimento_id: atendimentoId, ...dados });
    }

    obterPaciente(atendimentoId) {
        return api.get(RECURSO_PACIENTE, { params: { atendimento_id: atendimentoId } });
    }

    atualizarPaciente(atendimentoId, dados) {
        return api.put(RECURSO_PACIENTE, { atendimento_id: atendimentoId, ...dados });
    }
}

const linhaCuidadoService = new LinhaCuidadoService();

export default linhaCuidadoService;
